import React, { useEffect, useState } from "react";
import {
  Grid,
  Box,
  Typography,
  Avatar,
  Radio,
  FormControlLabel,
  RadioGroup,
  Button,
} from "@mui/material";
import "./SwapShiftModalAR.css";
import CustomModal from "../../CustomModal/CustomModal";
import ModalHeader from "../../CustomModal/ModalHeader";
import * as _ from "lodash";
import moment from "moment";

import { themes, fonts } from "../../../themes/themes";
import { DataGrid } from "@mui/x-data-grid";
import Loader from "../../../Lottifiers/Loader/Loader";
import { useTranslation } from "react-i18next";
import { toast } from "react-hot-toast";
import Compdirection from "../../../themes/CompDirection";
import EmployeeNamePic from "../../../components/EmployeeNamePic/EmployeeNamePic";
import GetPayHistoryActionBox from "../../../components/ActionIcons/GetPayHistoryActionBox/GetPayHistoryActionBox";
import TakeActionSplitBtn from "../../../components/TakeActionSplitBtn/TakeActionSplitBtn";
interface ModalProps {
  isModalOpen?: boolean;
  closeModal: any;
}

const SwapShiftModalPresenter = ({ isModalOpen, closeModal }: ModalProps) => {
  const { t, i18n } = useTranslation();
  const trans: any = t;
  const [openModal, setOpenModal] = useState(false);

  const tableColumns: any = [
    {
      field: "appliedOn",
      headerName: trans("Applied On"),
      width: 200,
      flex: 1,
      headerAlign: "center",
      align: "center",
      headerClassName: "header",
      height: 70,
    },
    {
      field: "requestBy",
      headerName: trans("Request By"),
      width: 200,
      flex: 1,
      headerAlign: "center",
      align: "center",
      headerClassName: "header",
      height: 70,
      renderCell: (params: any) => {
        return <EmployeeNamePic name="Khanzada Hanzla" picture="" />;
      },
    },
    {
      field: "swapTo",
      headerName: trans("Swap To"),
      width: 200,
      flex: 1,
      headerAlign: "center",
      align: "center",
      headerClassName: "header",
      height: 70,
      renderCell: (params: any) => {
        return <EmployeeNamePic name="Amelia Russel" picture="" />;
      },
    },
    {
      field: "status",
      headerName: trans("Status"),
      width: 200,
      flex: 1,
      headerAlign: "center",
      align: "center",
      headerClassName: "header",
      height: 70,
    },

    {
      field: "action",
      flex: 1,
      headerName: trans("Action"),
      headerClassName: "header",
      headerAlign: "center",
      align: "center",
      renderCell: (params: any) => {
        return (
          <GetPayHistoryActionBox
            onView={() => {
              setOpenModal(true);
            }}
          />
        );
      },

      width: 200,
      height: 70,
    },
  ];

  const row_data = [{ id: 1, appliedOn: "30/07/2022", status: "Pending" }];
  const tableColumns2: any = [
    {
      field: "appliedOn",
      headerName: trans("Applied On"),
      width: 200,
      flex: 1,
      headerAlign: "center",
      align: "center",
      headerClassName: "header",
      height: 70,
    },
    {
      field: "requestBy",
      headerName: trans("Request By"),
      width: 200,
      flex: 1,
      headerAlign: "center",
      align: "center",
      headerClassName: "header",
      height: 70,
      renderCell: (params: any) => {
        return <EmployeeNamePic name="Khanzada Hanzla" picture="" />;
      },
    },
    {
      field: "swapTo",
      headerName: trans("Swap To"),
      width: 200,
      flex: 1,
      headerAlign: "center",
      align: "center",
      headerClassName: "header",
      height: 70,
      renderCell: (params: any) => {
        return <EmployeeNamePic name="Amelia Russel" picture="" />;
      },
    },
    {
      field: "status",
      headerName: trans("Status"),
      width: 200,
      flex: 1,
      headerAlign: "center",
      align: "center",
      headerClassName: "header",
      height: 70,
    },

    {
      field: "action",
      flex: 1,
      headerName: trans("Action"),
      headerClassName: "header",
      headerAlign: "center",
      align: "center",
      renderCell: (params: any) => {
        return (
          <GetPayHistoryActionBox
            onView={() => {
              setOpenModal(true);
            }}
          />
        );
      },

      width: 200,
      height: 70,
    },
  ];

  const row_data2 = [{ id: 1, appliedOn: "30/07/2022", status: "Pending" }];

  return (
    <CustomModal
      isModalOpen={isModalOpen}
      modalHeight="100vw"
      modalWidth="95vw"
    >
      <ModalHeader
        modal={{ modal_title: trans("Swap Shift") }}
        closeModal={closeModal}
      />
      <Grid
        container
        spacing={2}
        style={{
          marginTop: "5px",
        }}
      >
        <Grid item xs={6}>
          <Box
            style={{
              border: "1px solid #0000001F",
              borderRadius: "8px",
              padding: "10px",
              height: "auto",
              maxHeight: "400px",
            }}
          >
            <Grid container spacing={2}>
              <Grid item>
                <Avatar src={"employee_profile_pic"} />
              </Grid>
              <Grid item>
                <Typography
                  style={{
                    fontFamily: fonts.fontFamily,
                    fontSize: fonts.title,
                    color: themes.darkBlue,
                    fontWeight: "bold",
                  }}
                >
                  {"Khanzada"}
                </Typography>
                <Typography
                  style={{
                    fontFamily: fonts.fontFamily,
                    fontSize: fonts.subtitle,
                    color: themes.defaultIcon,
                  }}
                >
                  {"UX Designer"}
                </Typography>
              </Grid>
            </Grid>
            <Box style={{ marginBottom: "10px" }} />
            <Compdirection>
              <Grid container>
                <Grid item>
                  <Box
                    sx={{
                      "& .header": {
                        backgroundColor: "#F5F5F5",
                      },
                    }}
                    className="main_table_swap_shift_AR"
                  >
                    <DataGrid
                      disableColumnMenu
                      sx={{
                        color: "#081735",
                        font: "normal normal normal 14px/24px Lato;",
                      }}
                      autoHeight
                      disableExtendRowFullWidth
                      columns={tableColumns}
                      rows={row_data}
                      componentsProps={{
                        pagination: {
                          labelRowsPerPage: trans("Rows per page"),
                        },
                      }}
                    />
                  </Box>
                </Grid>
              </Grid>
            </Compdirection>
          </Box>
        </Grid>

        {/* third box */}
        <Grid item xs={6}>
          <Box
            style={{
              border: "1px solid #7C0E6F",
              borderRadius: "8px",
              padding: "10px",
              height: "400px",
              boxShadow: "1px 9px 9px #f2e6f0",
            }}
          >
            <>
              <Grid container spacing={2}>
                <Grid item>
                  <Avatar src={""} />
                </Grid>
                <Grid item>
                  <Typography
                    style={{
                      fontFamily: fonts.fontFamily,
                      fontSize: fonts.title,
                      color: themes.darkBlue,
                      fontWeight: "bold",
                    }}
                  >
                    Shah khan
                  </Typography>
                  <Typography
                    style={{
                      fontFamily: fonts.fontFamily,
                      fontSize: fonts.subtitle,
                      color: themes.defaultIcon,
                    }}
                  >
                    Soft Developer{" "}
                  </Typography>
                </Grid>
              </Grid>
              <Box style={{ marginBottom: "10px" }} />
              <Compdirection>
                <Grid container>
                  <Grid item>
                    <Box
                      sx={{
                        "& .header": {
                          backgroundColor: "#F5F5F5",
                        },
                      }}
                      className="main_table_swap_shift_AR"
                    >
                      <DataGrid
                        disableColumnMenu
                        sx={{
                          color: "#081735",
                          font: "normal normal normal 14px/24px Lato;",
                        }}
                        autoHeight
                        disableExtendRowFullWidth
                        columns={tableColumns2}
                        rows={row_data2}
                        componentsProps={{
                          pagination: {
                            labelRowsPerPage: trans("Rows per page"),
                          },
                        }}
                      />
                    </Box>
                  </Grid>
                </Grid>
              </Compdirection>
            </>
          </Box>
        </Grid>
        <Grid item flex={1}></Grid>
        <Grid item>
          <Button
            style={{
              color: "#F44336",
              border: "1px solid #F44336",
              borderRadius: "5px",
              padding: "5px",
              alignSelf: "center",
              fontFamily: "Lato",
            }}
          >
            Close
          </Button>
        </Grid>
        <Grid item>
          <TakeActionSplitBtn title={"Take Action"} />
        </Grid>
      </Grid>
    </CustomModal>
  );
};

export default SwapShiftModalPresenter;
